import script from "./InstructionNetHuntPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionNetHuntPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionNetHuntPage.vue?vue&type=style&index=0&id=f3e8cb68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3e8cb68"]])

export default __exports__